var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivestock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 46,
    viewBox: "0 0 55 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 20.7001H3.8V45.6001H5.8V20.7001Z",
    fill: "#12589F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1 45.7H28.1V38.2C27.3 38.3 26.2 38.4 24.8 38.4C21.9 38.4 18.1 37.7 16.3 37.4C15.8 39.7 13.7 41.5 11.2 41.5H10V45.6H8V39.5H11.2C13 39.5 14.5 38 14.5 36.2V35L15.7 35.3C15.8 35.3 21.2 36.5 24.9 36.5C27.3 36.5 29 36.1 29 36.1L30.2 35.8L30.1 45.7Z",
    fill: "#12589F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 45.7H31.5V34.4L37.3 38.3L37.4 38.8C37.5 39.2 37.6 39.8 37.7 39.9C38.1 40.2 40.5 42.4 41.4 43.2H41.9V35.8H43.9V45L40.6 45.1L40.3 44.8C39.3 43.9 36.7 41.6 36.3 41.3C35.7 40.8 35.5 39.9 35.3 39.4L33.4 38.1V45.7H33.5Z",
    fill: "#12589F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 36.2001H0V23.4C0 21.4 1.6 19.8 3.6 19.8H9L28.6 20.5L28.8 20.6C34.3 23.1 37.7 27.2 37.9 27.4L40.6 30.7001C40.9 30.7001 41.3 30.7 41.6 30.8C43.1 31 44.6 31.7001 45.9 32.7001L44.6 34.3C43.6 33.5 42.5 33 41.3 32.8C40.9 32.7 40.5 32.7001 40.2 32.7001H39.7L36.4 28.6C36.4 28.6 33.2 24.7 28.2 22.4L8.9 21.7001H3.6C2.7 21.7001 2 22.4 2 23.3V36.2001Z",
    fill: "#12589F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 1H49.3V16.5H51.3V1Z",
    fill: "#12589F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6 16.5H45.6V14.2C44.4 13.9 43.3 13 42.9 11.8C41.7 12 39.5 12.4 37.9 12.4C36.2 12.4 35.1 12.1 35 12.1L35.4 10.1C35.4 10.1 36.4 10.3 37.9 10.3C40.1 10.3 43.5 9.60005 43.5 9.60005L44.7 9.30005V10.5C44.7 11.4 45.4 12.2 46.4 12.2H47.6V16.5Z",
    fill: "#12589F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 16.5L25.6 16.4V10.2H27.6V14.3C28.2 13.7 29.2 12.8 29.6 12.5C29.6 12.4 29.7 12.2 29.7 12L29.8 11.5L34.1 8.59998V16.4H32.1V12.4L31.6 12.7C31.5 13.1 31.3 13.7 30.9 14C30.7 14.2 29.3 15.4 28.4 16.2L28.2 16.5Z",
    fill: "#12589F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3 10.6H52.3V3.2C52.3 2.5 51.8 2 51.1 2H47.8L35.9 2.4C32.9 3.8 31 6.1 31 6.1L28.8 8.8H28.3C28.1 8.8 27.9 8.8 27.7 8.8C27 8.9 26.4 9.2 25.8 9.6L24.5 8C25.3 7.3 26.3 6.9 27.3 6.7C27.5 6.7 27.6 6.7 27.8 6.6L29.4 4.7C29.5 4.6 31.7 1.9 35.2 0.4L35.4 0.3L47.7 0H51.1C52.9 0 54.3 1.4 54.3 3.2V10.6Z",
    fill: "#12589F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 11.2H8.3V13.2H14.4V11.2Z",
    fill: "#12589F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 11.2H4.4V13.2H6.6V11.2Z",
    fill: "#12589F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 14.5H10.1V16.5H18.8V14.5Z",
    fill: "#12589F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 27.1H48.3V29.1H54.4V27.1Z",
    fill: "#12589F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6 23.8H43.9V25.8H52.6V23.8Z",
    fill: "#12589F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivestock);
export default __webpack_public_path__ + "static/media/livestock.2a288cb34812ef9355d12fa1cf1f0f8d.svg";
export { ForwardRef as ReactComponent };